// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"cG","blender_bottle_img":"eG","blender_bottle_info":"fG","blender_bottle_title":"gG","blender_bottle_bold":"hG","blender_bottle_usual":"iG","blender_bottle_item_mob":"jG","addbutton":"kG","blender_bottle_title_mob":"lG","blender_bottle_bold_mob":"mG","blender_bottle_usual_mob":"nG","bolder":"oG","bottom_margin_4":"pG","bottom_margin_16":"qG"};
    if(module.hot) {
      // 1738064241677
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  